import { Locale } from "@redotech/crdb-enums/common/locale";
import * as z from "zod";

export const TRANSLATE_PORTAL_CUSTOMIZATION_ENTRIES_LIMIT = 30;

/** AI starting copy for portal-builder text. Nothing is persisted until save. */
export const translatePortalCustomizationText = {
  name: "translatePortalCustomizationText" as const,
  input: z.object({
    entries: z
      .array(
        z.object({ key: z.string().max(200), message: z.string().max(5000) }),
      )
      .max(TRANSLATE_PORTAL_CUSTOMIZATION_ENTRIES_LIMIT),
    targetLanguages: z.array(z.enum(Locale)).max(20),
  }),
  output: z.object({
    translations: z.record(z.string(), z.record(z.string(), z.string())),
  }),
};
